/**
 * BattleGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { BattleData } from './battle_data'

/**
 * BattleGetRes
 */
export interface BattleGetRes {
  /** 对线群详情 */
  items?: BattleData[]
}

/**
 * BattleGetRes Schema
 */
export const BattleGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '对线群详情',
      format: '[]*model.BattleData',
      items: { $ref: 'BattleData', description: '' },
      type: 'array',
      label: '对线群详情',
    },
  },
  type: 'object',
}
